import React from "react";

const NotAllowedView = () => null;

export default NotAllowedView;
